import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeContainerType } from './normalize';

export const fetchContainerType = createProvider(api.fetchContainerType)
  .andThen((res) => normalizeContainerType(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
